var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurroundings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.855 90H60.4501L72.4426 70.4325L77.5576 73.5675L71.1651 84H100.145L86.7601 57.23L77.9626 71.8925L57.0001 35.955L38.5926 67.5125L33.4076 64.4875L57.0001 24.045L78.0376 60.1075L87.2401 44.77L109.855 90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 42C31.0376 42 27.0001 37.9625 27.0001 33C27.0001 28.0375 31.0376 24 36.0001 24C40.9626 24 45.0001 28.0375 45.0001 33C45.0001 37.9625 40.9626 42 36.0001 42ZM36.0001 30C34.3451 30 33.0001 31.345 33.0001 33C33.0001 34.655 34.3451 36 36.0001 36C37.6551 36 39.0001 34.655 39.0001 33C39.0001 31.345 37.6551 30 36.0001 30Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8277 42.1197L47.1789 47.8887L68.1781 53.8903L69.8269 48.1213L48.8277 42.1197Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9951 90H46.3826L30.6476 66.0725L17.7851 88.4925L12.5801 85.5075L30.2976 54.6225L49.6176 84H57.9951V90Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9422 60.1472L77.0453 65.8395L95.0447 71.8376L96.9416 66.1453L78.9422 60.1472Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 39H72.0001C72.0001 34.0375 76.0376 30 81.0001 30V36C79.3451 36 78.0001 37.345 78.0001 39Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0001 39H84.0001C84.0001 38.1975 83.6876 37.445 83.1226 36.8775C82.5576 36.31 81.8026 36 81.0001 36V30C83.4051 30 85.6651 30.935 87.3651 32.635C89.0651 34.335 90.0001 36.595 90.0001 39Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0001 39H84.0001C84.0001 34.0375 88.0376 30 93.0001 30V36C91.3451 36 90.0001 37.345 90.0001 39Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102 39H96.0001C96.0001 38.1975 95.6876 37.445 95.1226 36.8775C94.5576 36.31 93.8026 36 93.0001 36V30C95.4051 30 97.6651 30.935 99.3651 32.635C101.065 34.335 102 36.595 102 39Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 90H38.0926L19.3351 77.495L22.6651 72.505L39.9076 84H48.0001V90Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurroundings);
export default __webpack_public_path__ + "static/media/Surroundings.592e3fcd.svg";
export { ForwardRef as ReactComponent };